import {default as ReduxStore} from '.';

export const store = ReduxStore;
